import { addDoc, collection, doc, getFirestore, onSnapshot } from "firebase/firestore"
import { useState } from "react"
import { currentUser } from "../../util/currentUser"
import { app } from "../../util/firebase"



export  const ajoutCommande = (id) =>{

    console.log(id)
    onSnapshot(doc(getFirestore(app),"medocs", id),(snap)=>{
        let commande = snap.data()
        commande.id = snap.id
        
        addDoc(collection(getFirestore(app),"commandesClient"),{
            id_commande: commande.id,
            name_commande: commande.name,
            imgSrc_commande: commande.imgSrc,
            price_commande: commande.price,
            isValid: false,
            isArchived: false,
            pharmacie: commande.pharmacie,
            user: currentUser
        }).then(()=> alert("done"))
    })
}

